import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectLogsSummary({ summary }: { summary: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Thống kê hoạt động</h3>
      <div className="grid grid-cols-2 gap-4">
        {summary.map((item, idx) => (
          <div key={idx} className="p-3 rounded-md border border-slate-50 bg-slate-50/30 flex items-center gap-3">
             <div className={cn("w-8 h-8 rounded flex items-center justify-center shrink-0", item.bg, item.color)}>
                <i className={cn(item.icon, "text-base")} />
             </div>
             <div className="min-w-0">
                <p className="text-sm font-normal text-slate-900">{item.value}</p>
                <p className="text-xs font-normal text-slate-400 truncate"> {item.label}</p>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
